// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

//TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;
const limit = config.limit.virtuals || config.limit.default;

const getVirtualsError = (error) => {
  return {
    type: constants.GET_VIRTUALS_ERROR,
    error,
  };
};

const getVirtualsSuccess = (virtuals) => {
  return {
    type: constants.GET_VIRTUALS_SUCCESS,
    virtuals: virtuals,
  };
};

const getVirtualError = (error) => {
  return {
    type: constants.GET_VIRTUAL_ERROR,
    error,
  };
};

const getVirtualSuccess = (virtual) => {
  return {
    type: constants.GET_VIRTUAL_SUCCESS,
    virtual: virtual,
  };
};

const createNewVirtualSuccess = (virtual) => {
  return {
    type: constants.GET_VIRTUAL_SUCCESS,
    virtual: virtual,
  };
};

const getVirtuals = (filterParams) => {
  let apiURL = `${experienceAPIURL}/virtuals?limit=${limit}`;
  if (filterParams) {
    apiURL += '&' + filterParams.slice(1); // Remove extra & from the filter string
  }
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getVirtualsError(response.statusText));
        }
        dispatch(getVirtualsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getVirtualsError(error));
      });
  };
};

const getVirtual = (id) => {
  let apiURL = `${experienceAPIURL}/virtuals/${id}`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getVirtualError(response.statusText));
        }
        dispatch(getVirtualSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getVirtualError(error));
      });
  };
};

const getVirtualsByProductIdError = (error) => {
  return {
    type: constants.GET_VIRTUALS_BY_PRODUCT_ID_ERROR,
    error,
  };
};

const getVirtualsByProductIdSuccess = (virtuals) => {
  return {
    type: constants.GET_VIRTUALS_BY_PRODUCT_ID_SUCCESS,
    virtuals: virtuals,
  };
};

const getVirtualsByProductId = (productId) => {
  let apiURL = `${experienceAPIURL}/virtuals?productId=${productId}`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getVirtualsByProductIdError(response.statusText));
        }
        dispatch(getVirtualsByProductIdSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getVirtualsByProductIdError(error));
      });
  };
};

const createNewVirtual = () => {
  const virtual = { id: '-1', status: 'active' };
  return (dispatch) => {
    dispatch(createNewVirtualSuccess({ data: virtual }));
  };
};

const patchVirtualError = (error) => {
  return {
    type: constants.PATCH_VIRTUAL_ERROR,
    error,
  };
};

const patchVirtualSuccess = (virtual) => {
  return {
    type: constants.PATCH_VIRTUAL_SUCCESS,
    virtual: virtual,
  };
};

const patchVirtual = (virtual) => {
  let apiURL = `${experienceAPIURL}/virtuals/${virtual.id}`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: virtual };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchVirtualError(response.statusText));
        }
        dispatch(patchVirtualSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchVirtualError(error));
      });
  };
};

const putStopError = (error) => {
  return {
    type: constants.PUT_STOP_ERROR,
    error,
  };
};

const putStopSuccess = (virtual) => {
  return {
    type: constants.PUT_STOP_SUCCESS,
    virtual: virtual,
  };
};

const putStops = (virtualId, stops) => {
  let apiURL = `${experienceAPIURL}/virtuals/${virtualId}/stops`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'PUT', data: stops };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putStopError(response.statusText));
        }
        dispatch(putStopSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putStopError(error));
      });
  };
};

const postVirtualError = (error) => {
  return {
    type: constants.POST_VIRTUAL_ERROR,
    error,
  };
};

const postVirtualSuccess = (virtual) => {
  return {
    type: constants.POST_VIRTUAL_SUCCESS,
    virtual: virtual,
  };
};

const postVirtual = (newVirtual) => {
  let apiURL = `${experienceAPIURL}/virtuals`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'POST', data: newVirtual };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(postVirtualError(response.statusText));
        }
        dispatch(postVirtualSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(postVirtualError(error));
      });
  };
};

export {
  createNewVirtual,
  getVirtuals,
  getVirtualsByProductId,
  getVirtual,
  postVirtual,
  patchVirtual,
  putStops,
};
